import { environment } from '../environments/environment';

export class ApiEndpoints {
  static url: string = environment.apiUrl;
  // static url: string = 'http://localhost:3000/api';
}
